import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  smartChargingStoreSelectorKey,
  type SmartChargingState,
} from './smart-charging.state';

export const selectSmartChargingState =
  createFeatureSelector<SmartChargingState>(smartChargingStoreSelectorKey);

export const selectLicensePlateLookupState = createSelector(
  selectSmartChargingState,
  (state) => state.licensePlateLookup
);
